import React from 'react';
import { MenyLightContext } from '..';

export default () => {
  let { setHelloworldToMonitor1 } = React.useContext(MenyLightContext);

  React.useEffect(() => {
    setHelloworldToMonitor1('helloworld_to_monito22222');
  }, []);

  return <></>;
};
